export const MuiBackdrop = {
    styleOverrides: {
        root: ({ theme }) => ({
            position: 'absolute',
            // color: alpha(theme.palette.text.primary, 0.25),
            color: `color-mix(in oklab, ${theme.vars.palette.text.primary} 25%, transparent)`,
            // TODO: to delete later, since now CircularProgressBackdrop component is available
            // borderRadius: `${theme.shape.borderRadius}px`,
            zIndex: theme.zIndex.drawer + 1,
        }),
    },
};
